import { render, staticRenderFns } from "./virtualApply.vue?vue&type=template&id=366e52a2&scoped=true&"
import script from "./virtualApply.vue?vue&type=script&lang=js&"
export * from "./virtualApply.vue?vue&type=script&lang=js&"
import style0 from "./virtualApply.vue?vue&type=style&index=0&id=366e52a2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "366e52a2",
  null
  
)

export default component.exports